import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonIcon,
  IonLabel,
  IonItem,
  IonAvatar,
  IonButtons,
  IonText,
  IonMenuToggle,
  IonImg
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { closeOutline } from 'ionicons/icons';
import { LaunchReview } from '@awesome-cordova-plugins/launch-review';

import { ReactComponent as RateUsIcon } from 'assets/menu-icons/rate-us.svg';
import { ReactComponent as FeedbackIcon } from 'assets/menu-icons/feedback.svg';
import { ReactComponent as HelpIcon } from 'assets/menu-icons/help.svg';
import { ReactComponent as SignOutIcon } from 'assets/menu-icons/sign-out.svg';
import { ReactComponent as ServiceIcon } from 'assets/menu-icons/services.svg';
import { ReactComponent as YoutubeIcon } from 'assets/social-media/youtube.svg';
import { ReactComponent as TwitterIcon } from 'assets/social-media/twitter.svg';
import { ReactComponent as InstagramIcon } from 'assets/social-media/instagram.svg';
import { ReactComponent as FacebookIcon } from 'assets/social-media/facebook.svg';

import { getUrlFromPath, getAppVersion } from 'libs/helpers/helper.lib';
import userStore from 'stores/user.store';
import classes from './style.module.scss';

const Menu = () => {
  const { push } = useHistory();
  const menuToggleRef = useRef();
  const isAuthenticated = userStore.getIsAuthenticated();
  const user = userStore.getUser();
  const currentYear = moment().format('YYYY');
  const version = getAppVersion();

  return (
    <IonMenu
      side='start'
      contentId='main'
      disabled={!isAuthenticated}
      className={classes.mainMenu}
    >
      <IonHeader>
        <IonToolbar>
          <IonAvatar>
            {user && user.avatar ? (
              <IonImg
                src={getUrlFromPath(user.avatar)}
                alt={`${user.first_name} ${user.last_name}`}
              />
            ) : (
              <div className={classes.avatarChar}>
                {user && user.email[0].toUpperCase()}
              </div>
            )}
          </IonAvatar>
          <IonTitle>{`${user.first_name} ${user.last_name}`}</IonTitle>
          <IonButtons slot='end'>
            <IonMenuToggle ref={menuToggleRef}>
              <IonIcon icon={closeOutline} size='large' />
            </IonMenuToggle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={classes.menuBox}>
          <IonList lines='none'>
            <IonItem
              onClick={() => {
                menuToggleRef.current.click();
                push('/services');
              }}
              button
              detail={false}
            >
              <ServiceIcon />
              <IonLabel>Services</IonLabel>
            </IonItem>
            <IonItem
              onClick={() => {
                LaunchReview.launch();
              }}
              button
              detail={false}
            >
              <RateUsIcon />
              <IonLabel>Rate Us</IonLabel>
            </IonItem>
            <IonItem
              onClick={() => {
                menuToggleRef.current.click();
                push('/feedback');
              }}
              button
              detail={false}
            >
              <FeedbackIcon />
              <IonLabel>Feedback</IonLabel>
            </IonItem>
            <IonItem
              onClick={() => {
                menuToggleRef.current.click();
                push('/help');
              }}
              button
              detail={false}
            >
              <HelpIcon />
              <IonLabel>Help?</IonLabel>
            </IonItem>
          </IonList>
          <div>
            <div className={classes.socialMediaContainer}>
              <IonText>Follow us</IonText>
              <div className={classes.socialMediaIconBox}>
                <a
                  href='https://www.youtube.com/c/BARWIS/featured'
                  target='_blank'
                  rel='noreferrer'
                >
                  <YoutubeIcon />
                </a>
                <a
                  href='https://www.instagram.com/barwismethods/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <InstagramIcon />
                </a>
                <a
                  href='https://twitter.com/BarwisMethods'
                  target='_blank'
                  rel='noreferrer'
                >
                  <TwitterIcon />
                </a>
                <a
                  href='https://www.facebook.com/BarwisMethods'
                  target='_blank'
                  rel='noreferrer'
                >
                  <FacebookIcon />
                </a>
              </div>
            </div>
            <IonItem
              onClick={() => userStore.logout()}
              button
              detail={false}
              lines='none'
              className={classes.logoutButton}
            >
              <SignOutIcon />
              <IonLabel>Logout</IonLabel>
            </IonItem>
            <div className={classes.appInfo}>
              <IonText className={`${classes.appInfo__version} big`}>
                Version{' '}
                <span className={classes.appInfo__version__highlight}>
                  {version}
                </span>
              </IonText>
              <IonText className={classes.appInfo__copyright}>
                Copyrights &copy; Barwis {currentYear}
              </IonText>
              <IonText className={`${classes.appInfo__company} small`}>
                Design & Developed by Zlines Solution
              </IonText>
            </div>
          </div>
        </div>
      </IonContent>
    </IonMenu>
  );
};

export default observer(Menu);
